import { useEffect, useRef, useState } from "react";

import TextArea from "../../../../../../Components/Inputs/TextArea";

import TextInput from "../../../../../../Components/Inputs/TextInput";

import NumberInput from "../../../../../../Components/Inputs/NumberInput";

import BtnRounded from "../../../../../../Components/Buttons/BtnRounded";

import useHandleFormError from "../../../../../../Hooks/useHandleFormError";

import useAxios from "../../../../../../Hooks/useAxios";

import useApp from "../../../../../../Hooks/useApp";

import { useNavigate } from "react-router-dom";
import usePouchCud from "./../../../../Hooks/usePouchCud";

const InvestigationDetails = () => {
  const input = useRef({ form: {}, err: {} });

  const [showError, setShowError] = useState(0);

  const formErrors = useHandleFormError();

  const { setShowSuccessModal, setModalMessage } = useApp();

  const navigate = useNavigate();

  const request = useAxios();

  const { create } = usePouchCud();

  const submit = async () => {
    setShowError(showError + 1);

    if (formErrors({ input })) return;

    let res = await request({
      method: "POST",
      url: "diagnosis/add",
      data: {
        name: input.current.form.name,
        code: input.current.form.code,
        description: input.current.form.description,
      },
    });

    if (res !== "error") {
      await create({ name: "investigation", doc: res });
      setModalMessage("Investigation Added Successfully");
      setShowSuccessModal(true);
      navigate("../");
    }
  };

  return (
    <div
      className="flex flex-col bg-white rounded-2xl px-5 mt-3"
      style={{ width: "50%" }}
    >
      <div className="flex w-full flex-col md:flex-row gap-x-4">
        <div className="flex w-full md:w-full flex-col ">
          <TextInput
            initial={""}
            input={input}
            showError={showError}
            inputKey="name"
            mt={0.5}
            config={{
              required: true,
              label: "Name",
              placeholder: "Eg. XRAY",
              maxChar: 250,
              minChar: 4,
            }}
          />

          <TextInput
            initial={""}
            input={input}
            showError={showError}
            inputKey="code"
            mt={0.5}
            config={{
              required: true,
              label: "Code",
              placeholder: "Eg. IEG6",
              maxChar: 250,
              minChar: 4,
            }}
          />

          <TextArea
            initial={""}
            input={input}
            showError={showError}
            inputKey="description"
            mt={0.5}
            config={{
              required: true,
              label: "Description",
              placeholder: "Investigation description",
              maxChar: 250,
              minChar: 4,
            }}
          />
        </div>
      </div>
      <div className="w-full mx-auto pb-4">
        <BtnRounded mt={2} click={submit} className="btn">
          <p className=" font-pop-reg">Continue</p>
        </BtnRounded>
      </div>
    </div>
  );
};

export default InvestigationDetails;
